import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tabs: {
    active: {
      appointments: [],
      page: 0,
      pageSize: 10,
      totalPages: 0,
      hasMore: true,
      totalCount: 0,
      loading: false,
      error: null,
    },
    scheduled: {
      appointments: [],
      page: 0,
      pageSize: 10,
      totalPages: 0,
      hasMore: true,
      totalCount: 0,
      loading: false,
      error: null,
    },
    closed: {
      appointments: [],
      page: 0,
      pageSize: 10,
      totalPages: 0,
      hasMore: true,
      totalCount: 0,
      loading: false,
      error: null,
    },
  },
  activeTab: "active",
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { tab, loading } = action.payload;
      if (state.tabs[tab]) {
        state.tabs[tab].loading = loading;
      }
    },
    setError: (state, action) => {
      const { tab, error } = action.payload;
      if (state.tabs[tab]) {
        state.tabs[tab].error = error;
        state.tabs[tab].loading = false;
      }
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    clearAllTabs: (state) => {
      Object.keys(state.tabs).forEach((tab) => {
        state.tabs[tab] = {
          ...initialState.tabs[tab],
        };
      });
    },
    setAppointments: (state, action) => {
      const { items, totalPages, totalItems, pageNumber, tab } = action.payload;
      if (state.tabs[tab]) {
        state.tabs[tab] = {
          ...state.tabs[tab],
          appointments: items,
          page: pageNumber,
          totalPages: totalPages,
          totalCount: totalItems,
          hasMore: pageNumber < totalPages,
          loading: false,
          error: null,
        };
      }
    },
    appendAppointments: (state, action) => {
      const { items, totalPages, pageNumber, tab } = action.payload;
      if (state.tabs[tab]) {
        const currentTab = state.tabs[tab];
        const uniqueNew = items.filter(
          (apt) => !currentTab.appointments.some((a) => a.id === apt.id)
        );
        currentTab.appointments = [...currentTab.appointments, ...uniqueNew];
        currentTab.page = pageNumber;
        currentTab.totalPages = totalPages;
        currentTab.hasMore = pageNumber < totalPages;
      }
    },
  },
});

export const {
  setLoading,
  setError,
  setActiveTab,
  clearAllTabs,
  setAppointments,
  appendAppointments,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
